import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import Overview from '@/b2c/PlanDetail/Overview';
import Detail from '@/b2c/PlanDetail/Detail';
import FormDownload from '@/b2c/PlanDetail/FormDownload';
import AssetsSelection from '@/b2c/PlanDetail/AssetsSelection';

const Tab = ({plan, skipFormDownload}) => {
  const {t: tr} = useTranslation('planDetail');
  const [showFDtab, setShowFDtab] = useState(false);
  const [currentTab, setCurrentTab] = useState('plan_overview');

  useEffect(
    () => {
      if (!plan.isShowAssetsSelection && currentTab === 'assets_selection') {
        setCurrentTab('plan_overview');
      }
    },
    [plan]
  );

  // FIXME: Need to fix css in Details
  return (
    <section>
      <ul className='nav nav-tabs'>
        <li>
          <a
            data-toggle='tab'
            className={currentTab === 'plan_overview' ? 'active' : ''}
            href='#plan_overview'
            onClick={() => setCurrentTab('plan_overview')}
          >
            {tr('overview')}
          </a>
        </li>
        <li>
          <a
            data-toggle='tab'
            className={currentTab === 'plan_details' ? 'active' : ''}
            href='#plan_details'
            onClick={() => setCurrentTab('plan_details')}
          >
            {tr('details')}
          </a>
        </li>
        {plan.isShowAssetsSelection && (
          <li>
            <a
              data-toggle='tab'
              className={currentTab === 'assets_selection' ? 'active' : ''}
              href='#assets_selection'
              onClick={() => setCurrentTab('assets_selection')}
            >
              {tr('assets_selection')}
            </a>
          </li>
        )}
        {!skipFormDownload && showFDtab && (
          <li>
            <a
              data-toggle='tab'
              className={currentTab === 'download_form' ? 'active' : ''}
              href='#download_form'
              onClick={() => setCurrentTab('download_form')}
            >
              {tr('form_download')}
            </a>
          </li>
        )}
      </ul>
      <div className='tab-content'>
        <div
          id='plan_overview'
          className={`tab-pane ${
            currentTab === 'plan_overview' ? 'active show' : ''
          }`}
        >
          <Overview plan={plan} />
        </div>
        <div
          id='plan_details'
          className={`tab-pane ${
            currentTab === 'plan_details' ? 'active show' : ''
          }`}
        >
          <Detail plan={plan} />
        </div>
        {plan.isShowAssetsSelection && (
          <div
            id='assets_selection'
            className={`tab-pane ${
              currentTab === 'assets_selection' ? 'active show' : ''
            }`}
          >
            <AssetsSelection plan={plan} />
          </div>
        )}
        {!skipFormDownload && (
          <div
            id='download_form'
            className={`tab-pane ${
              currentTab === 'download_form' ? 'active show' : ''
            }`}
          >
            <FormDownload plan={plan} setShowFDtab={setShowFDtab} />
          </div>
        )}
      </div>
    </section>
  );
};

export default Tab;
